var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('section',{staticClass:"journey-section",attrs:{"id":"journey"}},[_c('v-container',[_c('p',[_vm._v("The Journey")]),_c('div',{staticClass:"journey-strip"},_vm._l((_vm.items),function(item){return _c('article',{key:item.id},[_c('span',[_vm._v(_vm._s(item.label))]),_c('strong',[_vm._v(_vm._s(item.value))])])}),0)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }